import React, { useEffect } from 'react'
import { useAppDispatch } from '../../hooks'
import { cartActions } from './actions'
import { CART_STORAGE_KEY } from '../../../constants/storageKeys'
import { CartItem } from './types'

/**
 * Componente para inicializar carrinho do localStorage ao carregar a aplicação
 * Deve ser usado uma vez no App.tsx
 */
export const CartInitializer: React.FC = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    // Carregar carrinho do localStorage na inicialização
    // O Redux Persist já faz isso automaticamente, mas podemos adicionar lógica adicional aqui
    try {
      const savedCart = localStorage.getItem(CART_STORAGE_KEY)
      if (savedCart) {
        const parsedCart = JSON.parse(savedCart) as CartItem[]
        // Converter as datas de string para Date objects
        const items = parsedCart.map((item: CartItem) => ({
          ...item,
          product: {
            ...item.product,
            createdAt: new Date(item.product.createdAt as unknown as string),
            updatedAt: new Date(item.product.updatedAt as unknown as string)
          }
        }))
        dispatch(cartActions.loadCart(items))
      }
    } catch (error) {
      console.error('Erro ao carregar carrinho do localStorage:', error)
      // Limpar dados corrompidos
      localStorage.removeItem(CART_STORAGE_KEY)
    }
  }, [dispatch])

  return null
}

